/**
 * filters an array of objects
 * an object gets selected if the value of the provided object-property
 * matches any value in a provided criteria-array
 *
 * difference to correspondData(): takes an array of numbers as criteria
 * instead a string-value
 *
 * @param   {array} data - data to filter
 * @param   {array} criteria - criterias to filter by
 * @param   {String} property - property to read
 *
 * @returns {array} filterData - filtered data
 */

const getOwnersByState = (data, criteria, property) => {
  return data.filter((element) => {
    return criteria.includes(element[property])
  })
}

export default getOwnersByState



// WEBPACK FOOTER //
// ./src/logic/getOwnersByState.js